import { useCapabilities } from 'wagmi';

export const useIsSmartWallet = ({ chainId }: { chainId: number | undefined }) => {
  const result = useCapabilities();
  if (!chainId || !result.data || !result.data[chainId]) return false;
  return result.data[chainId].atomic?.status === 'supported';
};
